import { ActionType } from "../action-types";
import { Action } from "../actions";
import { ConversationDto } from "../../dto/conversation";

export type ContactConversationState = {
  item: ConversationDto | null;
  isLoading: boolean;
  error: string | null;
};

export const contactConversationInitialState: ContactConversationState = {
  item: null,
  isLoading: false,
  error: null,
};

export const contactConversationReducer = (
  state: ContactConversationState = contactConversationInitialState,
  action: Action
): ContactConversationState => {
  switch (action.type) {
    case ActionType.SET_CONTACT_CONVERSATION_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        error: null,
      };

    case ActionType.SET_CONTACT_CONVERSATION:
      return {
        ...state,
        item: action.payload ?? null,
        isLoading: false,
        error: null,
      };

    case ActionType.RESET_CONTACT_CONVERSATION:
      return contactConversationInitialState;

    default:
      return state;
  }
};
